export class CourseTerm {
    $id: string;
    EndDate: string;
    Id: number;
    LongDescription: string;
    MediumDescription: string;
    ParentId: number;
    Sequence: number;
    ShortDescription: string;
    StartDate: string;
    TermTypeId: number;
    Code: string;
}